import { ImageDetail } from './types';
import one from './assets/1.jpg';
import two from './assets/2.jpg';
import three from './assets/3.jpg';
import four from './assets/4.jpg';
import five from './assets/5.JPG';
import seven from './assets/7.JPG';
import eight from './assets/8.JPG';
import nine from './assets/9.JPG';
import ten from './assets/10.JPG';
import eleven from './assets/11.jpg';
import twelve from './assets/12.PNG';
import thirteen from './assets/13.jpg';

export const imageDetails: ImageDetail[] = [
  {
    image: one,
    description: 'This was the first day we went out, and you basically followed me round lagos mainland to buy things that I really did not need, and the one I needed I could not get it that day'
  },
  {
    image: two,
    description: 'This was the day we went to Nike art gallery and we kinda snuck into one room and found some artifacts and you decided to try one lol'
  },
  {
    image: three,
    description: 'This was the day we went to stories for the first time, after checking that place for the buffet and the patio and we were not satisfied, especially that hot sun at the patio'
  },
  {
    image: four,
    description: 'This was the day we were both baked, LMAO! and we still went to paint that day 😂'
  },
  {
    image: five,
    description: 'This was when we went to Landmark and you were so excited to see the beach and the water'
  },
  {
    image: seven,
    description: 'This was when we went to Landmark and you were so excited to see the beach and the water'
  },
  {
    image: eight,
    description: 'This was when we went to Landmark and you were so excited to see the beach and the water'
  },
  {
    image: nine,
    description: 'This was when we went to Landmark and you were so excited to see the beach and the water'
  },
  {
    image: ten,
    description: 'This was when we went to Landmark and you were so excited to see the beach and the water'
  },
  {
    image: eleven,
    description: 'This was when we went to Landmark and you were so excited to see the beach and the water'
  },
  {
    image: twelve,
    description: 'This was when we went to Landmark and you were so excited to see the beach and the water'
  },
  {
    image: thirteen,
    description: 'This was when we went to Landmark and you were so excited to see the beach and the water'
  }
];
